import React,{ useState, useEffect } from "react";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { onChangeDefaultPaymentSystemSave } from "../../../store/Settings/actions";


export const DefaultPaymentSystem = ({paymentProviders, defaultProvider}) => {
    const [paySystem, setPaysystem] = useState({value: "" , label: ""} || "");
    const dispatch = useDispatch();
    const { t } = useTranslation();   

    const defaultPaymentOptions = ()=>{
        const options = [];
        for (let item in paymentProviders) {
            options.push({ value: item, label: paymentProviders[item]})        
        }
        return options
    }
    
    function toUpper(value) {
        if (!value) return value;      
        return value[0].toUpperCase() + value.slice(1);
    }
    
    useEffect(() => {
        setPaysystem({value: defaultProvider , label: toUpper(defaultProvider)});
    }, [defaultProvider]);
    
    const handleChange = (newValue) => {setPaysystem(newValue)};
    const handleSave = () => {dispatch(onChangeDefaultPaymentSystemSave(paySystem))};

    return (
        <div className="grid grid-cols-7 mt-3 mb-5">
            <div className="col-start-1 col-end-4 bg-white p-5 mr-4">
                <p className="font-bold text-xl">
                    {t("Default payment system")}
                </p>
                <p className="font-medium text-sm">
                    {t("Please default payment system for all restaurants")}
                </p>
            </div>

            <div className="col-start-4 col-end-8 rounded-lg shadow-md bg-white p-5">
                <div className="w-4/5 mb-4">
                    <Select
                        name="payment"
                        options={defaultPaymentOptions()}
                        value={paySystem}
                        onChange={handleChange}
                        placeholder={t("Select payment system")}
                        isSearchable={false}
                    />
                </div>

                <div className="text-right">
                    <button
                        type="submit"
                        className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-gray-900 hover:bg-gray-700 activ:bg-gray-800 focus:outline-none"
                        onClick={handleSave}
                    >
                        {t("Save")}
                    </button>                    
                </div>
            </div>
        </div>
    );
};
